// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import AutoResizeController from "./auto_resize_controller"
application.register("auto-resize", AutoResizeController) 

import ViacepController from "./viacep_controller"
application.register("viacep", ViacepController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import ExpandableSectionsController from "./expandable_sections_controller"
application.register("expandable-sections", ExpandableSectionsController)

import RuleBandFormController from "./rule_band_form_controller"
application.register("rule-band-form", RuleBandFormController)

import ClientBandOverrideFormController from "./client_band_override_form_controller"
application.register("client-band-override-form", ClientBandOverrideFormController)

import MatrixEditorController from "./matrix_editor_controller"
application.register("matrix-editor", MatrixEditorController)

import ClientMatrixEditorController from "./client_matrix_editor_controller"
application.register("client-matrix-editor", ClientMatrixEditorController)

import UserResponsibilityMatricesFilterController from "./user_responsibility_matrices_filter_controller"
application.register("user-responsibility-matrices-filter", UserResponsibilityMatricesFilterController)

import ClientRiskDecisionRuleFormController from "./client_risk_decision_rule_form_controller"
application.register("client-risk-decision-rule-form", ClientRiskDecisionRuleFormController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import ReportValidationController from "./report_validation_controller"
application.register("report-validation", ReportValidationController)

import RiskScoreChartController from "./risk_score_chart_controller"
application.register("risk-score-chart", RiskScoreChartController)

import FilterCollapseController from "./filter_collapse_controller"
application.register("filter-collapse", FilterCollapseController)